// extracted by mini-css-extract-plugin
export var container = "_ap-0";
export var content = "_ap-3";
export var customerTitle = "_ap-4";
export var empty = "_ap-5";
export var gray = "_ap-6";
export var header = "_ap-7";
export var info = "_ap-8";
export var loading = "_ap-2";
export var loadingCard = "_ap-9";
export var oneLine = "_ap-a";
export var personName = "_ap-e";
export var pillContainer = "_ap-b";
export var selected = "_ap-1";
export var text = "_ap-c";
export var twoLines = "_ap-d";
export var unread = "_ap-f";
export var unreadIndicator = "_ap-g";